/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	19-11-2021
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_digidag_sidemenu = {};

(function(){

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	
	this.onready = function() {

		/*
		Listeners: Bind
		*/
		$(document).on('click','.js-side-menu .category',function(e) {
			
			var _category = $(this).data('category');

			specific_digidag_sidemenu.toggleCategory(
				_category
			);

			/*
			Goto first scene
			*/
			// $('.js-sub-' + _category).find('.js-sub-item:first').trigger('click');

		});

		// $(document).on('click','.js-sub-item',function() {

		// 	var _scene = $(this).data('scene');
			
		// 	specific_digidag_sidemenu.subItemActive(
		// 		_scene
		// 	);

		// 	specific_digidag_sidemenu.load(
		// 		_scene
		// 	);

		// });
		
	};
		
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	/*
	Category: Toggle
	*/
	this.toggleCategory = function(
		category
	) {

		/*
		Sub: Show
		*/
		$('.js-side-menu').find('.sub').hide();
		$('.js-sub-' + category).show();

		/*
		Turn arrow
		*/
		$('.js-category').find('svg').css({
			'transform':'rotate(-180deg)'
		});
		$('.js-category-' + category).find('svg').css({
			'transform':'rotate(90deg)'
		});
		
	};

	/*
	Sub item: Click
	*/
	this.subItemActive = function(
		w
	) {
		
		/*
		Set: Active
		*/
		$('.js-sub-item[data-scene="' + w + '"]').find('svg').css({
			'opacity':1
		});

	};

	this.load = function(
		w
	) {

		/*
		Update pano
		*/
		window.history.pushState(
			'obj',
			'',
			globalUrl +'/' + _language +'/' + $('.js-settings-category').val() + '/' + w
		);

		/*
		Load URL
		*/
		specific_360.updateUrl('');

	};

}).apply(specific_digidag_sidemenu); 